import React, { JSX } from 'react';
import { Text, RichText, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type IntroParagraphProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseHeadline: Field<string>;
    BaseLeftContent: Field<string>;
    BaseRightContent: Field<string>;
    Background: Field<boolean>;
  };
};

const IntroParagraph = (props: IntroParagraphProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  const hasBg = !!fields.Background?.value;

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`intro-paragraph-${props.rendering?.uid}`}
    >
      <div className="intro-paragraph">
        <div
          className={`${hasBg ? 'bg-secondary' : 'bg-primary'} inner-vertical-spacing`}
        >
          <div className="content-wrapper jss-inner-container">
            <div className="inner-content">
              {props.fields?.BaseHeadline?.value && (
                <Text
                  tag="h2"
                  className="headline"
                  field={props.fields?.BaseHeadline}
                />
              )}
              <div className="text-content">
                {props.fields?.BaseLeftContent?.value && (
                  <RichText
                    className="osf-intro-copy left-content"
                    field={props.fields?.BaseLeftContent}
                    tag="p"
                  ></RichText>
                )}
                <div className="divider"></div>
                {props.fields?.BaseRightContent?.value && (
                  <RichText
                    tag=""
                    className="right-content osf-body-copy"
                    field={props.fields.BaseRightContent}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroParagraph;
